import { LANDING } from '@/constants/testIds';

const ITEMS = [
    'Du petit artisan',
    'Au grand groupe',
    '20 ans d\'expertise',
    'Aulnay-sous-Bois',
    'EPI certifiés CE',
    'Livraison IDF',
    'Flocage atelier',
    'Pros & particuliers',
];

export const Reassurance = () => {
    return (
        <section data-testid={LANDING.reassurance} className="relative bg-[#FFD500] text-black overflow-hidden">
            <div className="h-1.5 hazard-stripes-thin" />
            <div className="py-5 sm:py-6 flex overflow-hidden">
                <div className="flex shrink-0 animate-marquee gap-10 sm:gap-14 pr-10 sm:pr-14">
                    {[...ITEMS, ...ITEMS].map((item, i) => (
                        <span
                            key={`a-${i}`}
                            className="font-display uppercase text-2xl sm:text-4xl lg:text-5xl whitespace-nowrap flex items-center gap-10 sm:gap-14"
                        >
                            {item}
                            <span className="inline-block h-3 w-3 sm:h-4 sm:w-4 bg-black rotate-45" aria-hidden="true" />
                        </span>
                    ))}
                </div>
            </div>
            <div className="h-1.5 hazard-stripes-thin" />
        </section>
    );
};
